import React from 'react';
import { AlertColor } from '@mui/material';

export type muiColorType =
    | AlertColor
    | 'inherit'
    | 'primary'
    | 'secondary'
    | undefined;

export type muiButtonVariantTypes = 'text' | 'contained' | 'outlined' | undefined;

interface OptionProps {
    message?: any;
    color?: muiColorType;
    variant?: muiButtonVariantTypes;
    Icon?: React.ReactNode;
}
export interface alertProps {
    open: boolean;
    message: any;
    severity?: AlertColor;
    denyOptions?: OptionProps;
    acceptOptions?: OptionProps;
}

export const alertInitialState: alertProps = {
    open: false,
    message: 'Successful',
    severity: 'success'
};

export type alertActionTypes =
    | { type: 'OPEN' }
    | { type: 'CLOSE' }
    | { type: 'UPDATE_ALERT'; message: any; severity: AlertColor }
    | { type: 'SET_DENY_OPTIONS'; options: OptionProps }
    | { type: 'SET_ACCEPT_OPTIONS'; options: OptionProps };

export const useAlert = () => {
    const [alert, dispatchAlert] = React.useReducer(
        (state: alertProps, action: alertActionTypes) => {
            switch (action.type) {
                case 'OPEN':
                    return { ...state, open: true };
                case 'CLOSE':
                    return { ...state, open: false };
                case 'UPDATE_ALERT':
                    return {
                        ...state,
                        message: action.message,
                        severity: action.severity
                    };
                default:
                    return state;
            }
        },
        alertInitialState
    );

    const closeAlert = React.useCallback(() => dispatchAlert({ type: 'CLOSE' }), []);

    return {
        alert,
        dispatchAlert,
        closeAlert
    };
};
